import Cookies from "js-cookie";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { APIS } from "../../../utils/APIS";
import { IDS } from "../../../utils/IDS";

// Products - Get All (Read)
export const GetAllProducts = createAsyncThunk(
    "commerce/products/get-all",
    async (filter, { rejectWithValue }) => {

        try {
            const res = await GET(
                `${APIS.Commerce.Products}?name=${filter?.name || ""}&product_id=${filter?.product_id || ""}&p_category_id=${filter?.p_category_id || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&sort_by=${filter?.sortBy || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const GetAllTopProducts = createAsyncThunk(
    "commerce/products/get-all-top",
    async (filter, { rejectWithValue }) => {

        try {
            const res = await GET(
                `${APIS.Commerce.Product}/top-products?name=${filter?.name || ""}&p_category_id=${filter?.p_category_id || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&sort_by=${filter?.sortBy || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
export const GetAllPeoplesChoiceProduct = createAsyncThunk(
    "commerce/products/get-all-choice",
    async (filter, { rejectWithValue }) => {

        try {
            const res = await GET(
                `${APIS.Commerce.Product}/peoples-choice-products?name=${filter?.name || ""}&p_category_id=${filter?.p_category_id || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&sort_by=${filter?.sortBy || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);


export const GetSingleProduct = createAsyncThunk(
    "commerce/products/get",
    async (id, { rejectWithValue }) => {
        try {
            const res = await GET(`${APIS.Commerce.Product}/${id}`);
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Products - Create (Add)
export const CheckAvailability = createAsyncThunk(
    "commerce/products/create",
    async ({ id, data }, { rejectWithValue }) => {

        console.log("THUNK RECEIVED DATA : ", data);

        try {
            const res = await GET(`${APIS.Commerce.CheckAvailibility}/${id}?check_in_date=${data?.check_in_date}&check_out_date=${data?.check_out_date}`);
            if (res?.success) {
                return res;
            }
            return rejectWithValue(res);// The new products object
        } catch (error) {
            console.log(error, 'error');

            return rejectWithValue(error);
        }
    }
);

// Products - Update
export const Update = createAsyncThunk(
    "commerce/products/update",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await PUT(`${APIS.Commerce.App_Setup} / ${id}`, data);
            return res;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

// Products - Delete
export const Delete = createAsyncThunk(
    "commerce/products/delete",
    async (id, { rejectWithValue }) => {
        try {
            const data = await DELETE(`${APIS.Commerce.App_Setup} / ${id}`);
            return id; // Return the id of the deleted products
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Products - Status
export const Status = createAsyncThunk(
    "commerce/products/status",
    async (id, { rejectWithValue }) => {
        try {
            const res = await POST(`${APIS.Commerce.App_Setup} / ${id}`);
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const Slice = createSlice({
    name: "products",
    initialState: {
        data: [],
        product: {},
        top_products: [],
        choice_products: [],
        current_page: IDS.PAGE,
        total_pages: IDS.TOTALPAGES,
        per_page: IDS.PERPAGE,
        total: IDS.TOTAL,
        status: IDS.SLICESTATUS.Idle,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Handling all actions for GetSingle, Create, Update, Delete
            .addCase(GetAllProducts.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetAllProducts.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.data = action.payload?.data || [];
                state.current_page = action.payload?.data?.current_page || IDS.PAGE;
                state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
                state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
                state.total = action.payload?.data?.total || IDS.TOTAL;
            })
            .addCase(GetAllProducts.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(GetAllTopProducts.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetAllTopProducts.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.top_products = action.payload?.data || [];
                state.current_page = action.payload?.data?.current_page || IDS.PAGE;
                state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
                state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
                state.total = action.payload?.data?.total || IDS.TOTAL;
            })
            .addCase(GetAllTopProducts.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(GetAllPeoplesChoiceProduct.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetAllPeoplesChoiceProduct.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.choice_products = action.payload?.data || [];
                state.current_page = action.payload?.data?.current_page || IDS.PAGE;
                state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
                state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
                state.total = action.payload?.data?.total || IDS.TOTAL;
            })
            .addCase(GetAllPeoplesChoiceProduct.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(GetSingleProduct.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetSingleProduct.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.product = action.payload?.data || [];
            })
            .addCase(GetSingleProduct.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(CheckAvailability.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(CheckAvailability.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                state.data.unshift(action.payload.data);
            })
            .addCase(CheckAvailability.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(Update.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Update.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                const index = state.data.findIndex(
                    (products) => products.id === action.payload?.data?.id
                );
                if (index !== -1) {
                    state.data[index] = action.payload.data;
                }
            })
            .addCase(Update.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(Delete.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Delete.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                state.data = state.data.filter(
                    (products) => products.id !== action.payload.id
                ); // Remove the products with the deleted id
            })
            .addCase(Delete.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })
            //
            .addCase(Status.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Status.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                state.data = state.data.filter(
                    (products) => products.id !== action.payload.id
                ); // Remove the products with the deleted id
            })
            .addCase(Status.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            });
    },
});

// Export actions (if needed in components)
export const { } = Slice.actions;

export default Slice.reducer;
